import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorPayout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M20.25 12A8.25 8.25 0 1 1 12 3.75a.75.75 0 0 0 0-1.5c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75a9.723 9.723 0 0 0-.809-3.893.75.75 0 0 0-1.375.599l.037.086c.416.985.647 2.069.647 3.208Zm-7.5-3a.75.75 0 0 0-1.5 0v.341a2.205 2.205 0 0 0 .023 4.409h1.454a.704.704 0 1 1 0 1.41h-2.285a.75.75 0 0 0 0 1.5h.808V17a.75.75 0 0 0 1.5 0v-.341a2.205 2.205 0 0 0-.023-4.409h-1.454a.705.705 0 0 1 0-1.41h2.286a.75.75 0 0 0 0-1.5h-.809V9Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M16.47 2.47a.75.75 0 0 1 1.06 0l3 3A.75.75 0 0 1 20 6.75h-7a.75.75 0 0 1 0-1.5h5.19l-1.72-1.72a.75.75 0 0 1 0-1.06Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorPayout;
